module.exports = __webpack_public_path__ + "img/item_link_ringsize.e9aa8e0.jpg";